import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/ui/PageHeader';
import { SectionHeading } from '../components/ui/SectionHeading';
import { StepList } from '../components/StepList';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { EntrepriseForm } from '../components/EntrepriseForm';
import { Users, FileText, Target, CheckCircle, FileSignature, HeartHandshake, Search, Briefcase, Euro, Award, ArrowDownCircle } from 'lucide-react';
const ENTREPRISE_STEPS = [{
  title: 'Sourcing et définition du besoin',
  description: 'Analyse de votre poste et définition du profil idéal avec nos conseillers.',
  icon: <Search className="w-6 h-6" data-id="element-1082" data-mp="2vdfbnqscb5bf" />
}, {
  title: 'Présélection des candidats',
  description: 'Nous vous présentons uniquement des profils qualifiés, motivés et préparés.',
  icon: <CheckCircle className="w-6 h-6" data-id="element-1083" data-mp="3o11gf2db0fzv" />
}, {
  title: 'Aide aux démarches administratives',
  description: "Accompagnement dans la rédaction et la signature du contrat d'apprentissage (CERFA).",
  icon: <FileSignature className="w-6 h-6" data-id="element-1084" data-mp="20tbnkonogx3n" />
}, {
  title: 'Suivi personnalisé',
  description: "Points réguliers avec le tuteur en entreprise tout au long du contrat pour garantir le succès de l'alternance.",
  icon: <HeartHandshake className="w-6 h-6" data-id="element-1085" data-mp="1d4irms722p91" />
}];
export function Entreprises() {
  const scrollToForm = () => {
    document.getElementById('formulaire-recrutement')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="flex flex-col w-full" data-id="element-1086" data-mp="144m44twejwfk">
      <PageHeader title="Espace Entreprises" subtitle="Recrutez vos futurs collaborateurs et dynamisez vos équipes grâce à l'alternance avec Zillenium." data-id="element-1087" data-mp="145xcl70slsd0" />

      {/* Top Jump Button */}
      <div className="bg-primary-dark text-white pb-12 pt-4 text-center -mt-1" data-id="element-1088" data-mp="2yg0yxp49sm26">
        <Button onClick={scrollToForm} className="bg-brand-orange hover:bg-[#E67E22] text-white text-lg px-8 py-6 rounded-full shadow-lg hover:scale-105 transition-transform" data-id="element-1089" data-mp="32intvyw8mn3l">
          Confier un recrutement <ArrowDownCircle className="ml-2 w-5 h-5" data-id="element-1090" data-mp="6abig2x0tr10" />
        </Button>
      </div>

      {/* Pourquoi recruter */}
      <section className="py-24 bg-white relative overflow-hidden" data-id="element-1091" data-mp="1brtrur1m14y">
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-lavande rounded-full blur-[100px] opacity-30 pointer-events-none" data-id="element-1092" data-mp="1dl2dfl7uvfl" />
        <div className="container max-w-6xl mx-auto relative z-10" data-id="element-1093" data-mp="tzdzb8jtzfug">
          <SectionHeading title="Pourquoi recruter avec Zillenium Alternance ?" centered data-id="element-1094" data-mp="u29xmxzlc6jf" />
          <div className="grid md:grid-cols-3 gap-8 mt-16" data-id="element-1095" data-mp="kamavadzbdoa">
            <Card className="border-none shadow-xl hover:-translate-y-2 transition-all duration-300 bg-white group" data-id="element-1096" data-mp="k801r6bfwq3y">
              <div className="h-2 w-full bg-brand-orange" data-id="element-1097" data-mp="1cyrws0grr8pp" />
              <CardContent className="p-8 text-center" data-id="element-1098" data-mp="1cx728augfpru">
                <div className="w-20 h-20 bg-lavande rounded-3xl flex items-center justify-center mx-auto mb-8 group-hover:scale-110 transition-transform duration-300" data-id="element-1099" data-mp="1kafxsl4acfly">
                  <Target className="w-10 h-10 text-brand-orange animate-soft-bounce" data-id="element-1100" data-mp="1pau869td01n5" />
                </div>
                <h3 className="font-extrabold font-heading text-2xl text-primary-dark mb-4" data-id="element-1101" data-mp="1y9pgpsjvlntm">
                  Des profils ciblés
                </h3>
                <p className="text-lg text-muted-foreground leading-relaxed" data-id="element-1102" data-mp="237zbw35loof8">
                  Des candidats préparés aux réalités du terrain et formés aux
                  techniques commerciales actuelles.
                </p>
              </CardContent>
            </Card>
            <Card className="border-none shadow-xl hover:-translate-y-2 transition-all duration-300 bg-white group" data-id="element-1103" data-mp="2hxy65uu1bfpf">
              <div className="h-2 w-full bg-primary" data-id="element-1104" data-mp="2m0l2a7xqnmsf" />
              <CardContent className="p-8 text-center" data-id="element-1105" data-mp="2qycwx9prpn0b">
                <div className="w-20 h-20 bg-primary/10 rounded-3xl flex items-center justify-center mx-auto mb-8 group-hover:scale-110 transition-transform duration-300" data-id="element-1106" data-mp="2qywake8dxp8j">
                  <FileText className="w-10 h-10 text-primary animate-soft-float" data-id="element-1107" data-mp="298zlu1oepcnc" />
                </div>
                <h3 className="font-extrabold font-heading text-2xl text-primary-dark mb-4" data-id="element-1108" data-mp="2n0e60bu1vjvz">
                  Zéro tracas administratif
                </h3>
                <p className="text-lg text-muted-foreground leading-relaxed" data-id="element-1109" data-mp="1ucs3z80h0nb8">
                  Nous vous guidons dans toutes les étapes de contractualisation
                  de votre alternant.
                </p>
              </CardContent>
            </Card>
            <Card className="border-none shadow-xl hover:-translate-y-2 transition-all duration-300 bg-white group" data-id="element-1110" data-mp="24civd0tqim73">
              <div className="h-2 w-full bg-brand-orange" data-id="element-1111" data-mp="1zdxy9a9s4imv" />
              <CardContent className="p-8 text-center" data-id="element-1112" data-mp="3fp1subug6hbn">
                <div className="w-20 h-20 bg-lavande rounded-3xl flex items-center justify-center mx-auto mb-8 group-hover:scale-110 transition-transform duration-300" data-id="element-1113" data-mp="3ar0cvzsbiy4e">
                  <Users className="w-10 h-10 text-brand-orange animate-soft-pulse" data-id="element-1114" data-mp="whxtqhgxov9o" />
                </div>
                <h3 className="font-extrabold font-heading text-2xl text-primary-dark mb-4" data-id="element-1115" data-mp="11g94cuf1z9sy">
                  Un partenaire de proximité
                </h3>
                <p className="text-lg text-muted-foreground leading-relaxed" data-id="element-1116" data-mp="sioyf868wpc0">
                  Un interlocuteur unique et réactif pour assurer le suivi de
                  votre apprenti en entreprise.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Missions en entreprise */}
      <section className="py-24 bg-muted" data-id="element-1117" data-mp="16flz01c61l63">
        <div className="container max-w-6xl mx-auto" data-id="element-1118" data-mp="1bfht98v29y8g">
          <SectionHeading title="Les missions en entreprise" subtitle="Quelles responsabilités confier à nos alternants pour les faire monter en compétences ?" centered data-id="element-1119" data-mp="1be6rfel6f0jz" />
          <div className="grid md:grid-cols-2 gap-8 mt-16" data-id="element-1120" data-mp="2dsj6x3b5j4dv">
            <Card className="border-none shadow-lg bg-white hover:shadow-xl transition-shadow" data-id="element-1121" data-mp="2ds1deefvj49n">
              <CardContent className="p-8" data-id="element-1122" data-mp="28uhnuidq752e">
                <div className="flex items-center gap-4 mb-6" data-id="element-1123" data-mp="23u3rvypeflkq">
                  <div className="w-12 h-12 bg-lavande rounded-xl flex items-center justify-center" data-id="element-1124" data-mp="23wpy9v0jzv1d">
                    <Briefcase className="w-6 h-6 text-primary-dark" data-id="element-1125" data-mp="1yxmvyibyk2x3" />
                  </div>
                  <h3 className="font-extrabold font-heading text-2xl text-primary-dark" data-id="element-1126" data-mp="1uw1lt4qt62ql">
                    Missions BTS NDRC
                  </h3>
                </div>
                <ul className="space-y-4 text-slate-600" data-id="element-1127" data-mp="1l4x6u514uhvr">
                  <li className="flex items-start gap-3" data-id="element-1128" data-mp="1g5asttdhcxlw">
                    <CheckCircle className="w-5 h-5 text-brand-orange shrink-0 mt-0.5" data-id="element-1129" data-mp="1g6vm7fo26ai6" />
                    <span data-id="element-1130" data-mp="1b5g3hu9csg2y">
                      <strong data-id="element-1131" data-mp="1b7sfzrwcdy8m">Prospection et développement :</strong> Recherche
                      de nouveaux clients, qualification de fichiers, prise de
                      rendez-vous.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1132" data-mp="3msjh2rmykknw">
                    <CheckCircle className="w-5 h-5 text-brand-orange shrink-0 mt-0.5" data-id="element-1133" data-mp="3mv5nup20yw52" />
                    <span data-id="element-1134" data-mp="3rqbe202gmwyy">
                      <strong data-id="element-1135" data-mp="luq4w2hck15">Négociation et vente :</strong> Conduite
                      d'entretiens commerciaux, élaboration de propositions,
                      conclusion de ventes.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1136" data-mp="343lcezu0x4ev">
                    <CheckCircle className="w-5 h-5 text-brand-orange shrink-0 mt-0.5" data-id="element-1137" data-mp="3926bgvxjhi1q" />
                    <span data-id="element-1138" data-mp="3dsmq2jd3j9po">
                      <strong data-id="element-1139" data-mp="3dswew3menats">Relation client digitale :</strong> Animation de
                      réseaux sociaux, gestion de l'e-réputation, e-mailing.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1140" data-mp="2lbacneuo1mkz">
                    <CheckCircle className="w-5 h-5 text-brand-orange shrink-0 mt-0.5" data-id="element-1141" data-mp="1eozvsegncwsb" />
                    <span data-id="element-1142" data-mp="1equi9x7kgwyi">
                      <strong data-id="element-1143" data-mp="19q6jgpd3jbtq">Fidélisation :</strong> Suivi client, gestion des
                      réclamations, ventes additionnelles.
                    </span>
                  </li>
                </ul>
              </CardContent>
            </Card>

            <Card className="border-none shadow-lg bg-white hover:shadow-xl transition-shadow" data-id="element-1144" data-mp="1ip9ztlkvpd4j">
              <CardContent className="p-8" data-id="element-1145" data-mp="1xm12q4trh6yw">
                <div className="flex items-center gap-4 mb-6" data-id="element-1146" data-mp="1sp0txm5j1q43">
                  <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center" data-id="element-1147" data-mp="1smohfoijg7yf">
                    <Briefcase className="w-6 h-6 text-primary" data-id="element-1148" data-mp="26i9zfbqctrhc" />
                  </div>
                  <h3 className="font-extrabold font-heading text-2xl text-primary-dark" data-id="element-1149" data-mp="22fdnu4z8evmw">
                    Missions TP Conseiller de Vente
                  </h3>
                </div>
                <ul className="space-y-4 text-slate-600" data-id="element-1150" data-mp="2bgtr7srmpxhm">
                  <li className="flex items-start gap-3" data-id="element-1151" data-mp="2v0iv813315d0">
                    <CheckCircle className="w-5 h-5 text-primary shrink-0 mt-0.5" data-id="element-1152" data-mp="2uyzb1zeb2a5y" />
                    <span data-id="element-1153" data-mp="2zzn4erq0b33c">
                      <strong data-id="element-1154" data-mp="2zxsojrtle164">Accueil et conseil :</strong> Prise en charge du
                      client, découverte des besoins, argumentation adaptée.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1155" data-mp="2caklzhnjt67s">
                    <CheckCircle className="w-5 h-5 text-primary shrink-0 mt-0.5" data-id="element-1156" data-mp="2c8zslvcyztbi" />
                    <span data-id="element-1157" data-mp="2h2ccxtam9dyg">
                      <strong data-id="element-1158" data-mp="2h2lvivtc0iu4">Vente et encaissement :</strong> Concrétisation de
                      la vente, proposition de services annexes, gestion de la
                      caisse.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1159" data-mp="1tbymg77ojn5z">
                    <CheckCircle className="w-5 h-5 text-primary shrink-0 mt-0.5" data-id="element-1160" data-mp="1tci2fidrs1hd" />
                    <span data-id="element-1161" data-mp="1xc0fjrzcn89n">
                      <strong data-id="element-1162" data-mp="1xfeip2fu7li5">Merchandising :</strong> Mise en rayon, maintien
                      de l'attractivité du point de vente, gestion des vitrines.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1163" data-mp="yvjb76vtjmjm">
                    <CheckCircle className="w-5 h-5 text-primary shrink-0 mt-0.5" data-id="element-1164" data-mp="kzfsoaub52mz" />
                    <span data-id="element-1165" data-mp="p0rb9werknlo">
                      <strong data-id="element-1166" data-mp="ozzrdiuj4eb8">Gestion des stocks :</strong> Réception des
                      marchandises, inventaires, suivi des ruptures.
                    </span>
                  </li>
                </ul>
              </CardContent>
            </Card>
          </div>
          <div className="mt-12 text-center" data-id="element-1167" data-mp="13vxj8oxf6whn">
            <Button onClick={scrollToForm} variant="outline" className="border-brand-orange text-brand-orange hover:bg-brand-orange hover:text-white text-lg px-8 py-6 rounded-full" data-id="element-1168" data-mp="13uw4a9da9pun">
              Proposer une mission <ArrowDownCircle className="ml-2 w-5 h-5" data-id="element-1169" data-mp="20fwovvgfo6k2" />
            </Button>
          </div>
        </div>
      </section>

      {/* Aides et Salaires (Vendre du rêve) */}
      <section className="py-24 bg-white relative overflow-hidden" data-id="element-1170" data-mp="3g6qnp5o1dg01">
        <div className="container max-w-6xl mx-auto" data-id="element-1171" data-mp="3g4ctt053e9u2">
          <SectionHeading title="Un recrutement très avantageux" subtitle="Profitez d'aides exceptionnelles de l'État pour l'embauche de nos alternants." centered data-id="element-1172" data-mp="3uu1y348hetyk" />

          <div className="grid md:grid-cols-3 gap-6 mt-16" data-id="element-1173" data-mp="326y0hkbpxhwt">
            <Card className="bg-gradient-to-br from-primary to-primary-dark text-white border-none shadow-xl transform hover:-translate-y-2 transition-transform" data-id="element-1174" data-mp="2x7ut3t89mzlo">
              <CardContent className="p-8 text-center" data-id="element-1175" data-mp="3c2iw90q71ly4">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1176" data-mp="374hcedky1ill">
                  <Euro className="w-8 h-8 text-white" data-id="element-1177" data-mp="rcthenphq05f" />
                </div>
                <h3 className="text-4xl font-extrabold font-heading mb-2" data-id="element-1178" data-mp="me8h6oa8nggz">
                  5 000 €*
                </h3>
                <p className="text-lg font-medium text-lavande mb-4" data-id="element-1179" data-mp="thyhitr1sl3d">par an</p>
                <p className="text-white/90" data-id="element-1180" data-mp="ygjl935idmwk">
                  Aide pour l'embauche d'un{' '}
                  <strong data-id="element-1181" data-mp="13hpdkzv9b85k">TP Conseiller de Vente</strong> (Niveau 4)
                </p>
              </CardContent>
            </Card>

            <Card className="bg-gradient-to-br from-brand-orange to-[#d6751f] text-white border-none shadow-xl transform hover:-translate-y-2 transition-transform" data-id="element-1182" data-mp="18eza0zh2ck2w">
              <CardContent className="p-8 text-center" data-id="element-1183" data-mp="fs4umgz3sawa">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1184" data-mp="kq6cwzopg66p">
                  <Euro className="w-8 h-8 text-white" data-id="element-1185" data-mp="pgmsoqg003w8" />
                </div>
                <h3 className="text-4xl font-extrabold font-heading mb-2" data-id="element-1186" data-mp="pipsg26ydbe5">
                  4 500 €*
                </h3>
                <p className="text-lg font-medium text-white/80 mb-4" data-id="element-1187" data-mp="3t5g9xtdqml7m">par an</p>
                <p className="text-white/90" data-id="element-1188" data-mp="2aava5g8mnbtr">
                  Aide pour l'embauche d'un <strong data-id="element-1189" data-mp="2aa2aez835ml4">BTS NDRC</strong> (Niveau 5)
                </p>
              </CardContent>
            </Card>

            <Card className="bg-gradient-to-br from-lavande to-[#d4c1f9] text-primary-dark border-none shadow-xl transform hover:-translate-y-2 transition-transform" data-id="element-1190" data-mp="267fikybf01nx">
              <CardContent className="p-8 text-center" data-id="element-1191" data-mp="1wakhq8ro5p6h">
                <div className="w-16 h-16 bg-primary-dark/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1192" data-mp="1rcj0zuhpu1y6">
                  <Euro className="w-8 h-8 text-primary-dark" data-id="element-1193" data-mp="1mk7z4m3f062z" />
                </div>
                <h3 className="text-4xl font-extrabold font-heading mb-2" data-id="element-1194" data-mp="1iiw94fgmpiu9">
                  6 000 €*
                </h3>
                <p className="text-lg font-medium text-primary-dark/70 mb-4" data-id="element-1195" data-mp="1dlvyrscqxtxc">
                  par an
                </p>
                <p className="text-primary-dark/90" data-id="element-1196" data-mp="18nm55m6o71du">
                  Aide maximale pour l'embauche d'un apprenti{' '}
                  <strong data-id="element-1197" data-mp="33oo7rbvdk6qn">PSH</strong> (Handicap)
                </p>
              </CardContent>
            </Card>
          </div>

          <p className="text-sm text-muted-foreground mt-6 text-center max-w-3xl mx-auto" data-id="element-1198" data-mp="38o0tftaif7rn">
            * Montants applicables aux entreprises de moins de 250 salariés.
            Pour les entreprises de 250 salariés et plus, l'aide est recalculée
            selon le niveau de qualification préparé :{' '}
            <button type="button" onClick={scrollToForm} className="text-brand-orange font-semibold underline underline-offset-2 hover:text-[#E67E22] transition-colors" data-id="element-1199" data-mp="2kx55x8d36yq7">
              contactez-nous pour en savoir plus
            </button>
            .
          </p>

          {/* Table des salaires */}
          <div className="mt-20" data-id="element-1200" data-mp="98mb3ee8r5vi">
            <h3 className="text-2xl font-extrabold font-heading text-primary-dark mb-8 text-center" data-id="element-1201" data-mp="99p2dnfh7aby">
              Grille des salaires des alternants
            </h3>
            <div className="overflow-x-auto rounded-2xl shadow-xl border border-slate-100" data-id="element-1202" data-mp="1ypremddcqsjf">
              <table className="w-full text-left border-collapse bg-white min-w-[800px]" data-id="element-1203" data-mp="1tqoi5hbftun2">
                <thead data-id="element-1204" data-mp="1totwg0scdyhx">
                  <tr className="bg-primary/5 text-primary-dark" data-id="element-1205" data-mp="28g2rwqixee2z">
                    <th className="p-4 font-bold border-b border-slate-200" data-id="element-1206" data-mp="28hnjq8duvix5">
                      Âge de l'alternant
                    </th>
                    <th className="p-4 font-bold border-b border-slate-200" data-id="element-1207" data-mp="2hfhhzov6kmmy">
                      1ère année
                    </th>
                    <th className="p-4 font-bold border-b border-slate-200" data-id="element-1208" data-mp="2de4dbi3tqphm">
                      2ème année
                    </th>
                    <th className="p-4 font-bold border-b border-slate-200" data-id="element-1209" data-mp="2mfc6jlrhh04u">
                      3ème année
                    </th>
                  </tr>
                </thead>
                <tbody className="text-slate-600" data-id="element-1210" data-mp="x2i7acnxa60c">
                  <tr className="border-b border-slate-100 hover:bg-slate-50 transition-colors" data-id="element-1211" data-mp="s245hccwzsar">
                    <td className="p-4 font-medium text-primary-dark" data-id="element-1212" data-mp="2s4c7fipsbj62">
                      Moins de 18 ans
                    </td>
                    <td className="p-4" data-id="element-1213" data-mp="2x2x7ni51e2ui">
                      27% du Smic
                      <br data-id="element-1214" data-mp="3137f6z8h91bh" />
                      <span className="font-bold text-primary text-lg" data-id="element-1215" data-mp="312xn963vgk35">
                        504,10 €
                      </span>
                    </td>
                    <td className="p-4" data-id="element-1216" data-mp="3b37xqiyivdem">
                      39% du Smic
                      <br data-id="element-1217" data-mp="3g19ir9fidmsq" />
                      <span className="font-bold text-primary text-lg" data-id="element-1218" data-mp="3g0hktryfvcza">
                        728,14 €
                      </span>
                    </td>
                    <td className="p-4" data-id="element-1219" data-mp="3ottjcffd21g7">
                      55% du Smic
                      <br data-id="element-1220" data-mp="3ot1qvdh28ju5" />
                      <span className="font-bold text-primary text-lg" data-id="element-1221" data-mp="3tsxp0w32th1s">
                        1 026,86 €
                      </span>
                    </td>
                  </tr>
                  <tr className="border-b border-slate-100 hover:bg-slate-50 transition-colors" data-id="element-1222" data-mp="2ka6enw807xx">
                    <td className="p-4 font-medium text-primary-dark" data-id="element-1223" data-mp="co71lsso0mk0">
                      18 à 20 ans
                    </td>
                    <td className="p-4" data-id="element-1224" data-mp="2ru92y8uwequ">
                      43% du Smic
                      <br data-id="element-1225" data-mp="2u6y1vd17pde" />
                      <span className="font-bold text-primary text-lg" data-id="element-1226" data-mp="3uwoc6umldnw3">
                        802,82 €
                      </span>
                    </td>
                    <td className="p-4" data-id="element-1227" data-mp="vj5iiz4mn3lv">
                      51% du Smic
                      <br data-id="element-1228" data-mp="qihwysz63ez1" />
                      <span className="font-bold text-primary text-lg" data-id="element-1229" data-mp="qkaspd88ses9">
                        952,18 €
                      </span>
                    </td>
                    <td className="p-4" data-id="element-1230" data-mp="hov2r7alyjry">
                      67% du Smic
                      <br data-id="element-1231" data-mp="1e82ct300xw43" />
                      <span className="font-bold text-primary text-lg" data-id="element-1232" data-mp="1e8c732s3qpfl">
                        1 250,90 €
                      </span>
                    </td>
                  </tr>
                  <tr className="border-b border-slate-100 hover:bg-slate-50 transition-colors" data-id="element-1233" data-mp="1t3tf76rbepga">
                    <td className="p-4 font-medium text-primary-dark" data-id="element-1234" data-mp="1xvtcssjwx69p">
                      21 à 25 ans*
                    </td>
                    <td className="p-4" data-id="element-1235" data-mp="1j8hyiiwcj85w">
                      53% du Smic
                      <br data-id="element-1236" data-mp="1o6t5mlv9b4kf" />
                      <span className="font-bold text-primary text-lg" data-id="element-1237" data-mp="1o61blfhb5ew9">
                        989,52 €
                      </span>
                    </td>
                    <td className="p-4" data-id="element-1238" data-mp="2gup3htwkb2is">
                      61% du Smic
                      <br data-id="element-1239" data-mp="21xessmrqu0o4" />
                      <span className="font-bold text-primary text-lg" data-id="element-1240" data-mp="21w4srs1byieu">
                        1 138,88 €
                      </span>
                    </td>
                    <td className="p-4" data-id="element-1241" data-mp="qhzlap1wrqer">
                      78% du Smic
                      <br data-id="element-1242" data-mp="qk3zq0xfo7ta" />
                      <span className="font-bold text-primary text-lg" data-id="element-1243" data-mp="vh2os528pokm">
                        1 456,28 €
                      </span>
                    </td>
                  </tr>
                  <tr className="hover:bg-slate-50 transition-colors" data-id="element-1244" data-mp="39qoigj0y3djc">
                    <td className="p-4 font-medium text-primary-dark" data-id="element-1245" data-mp="34p8w8nn170zd">
                      26 ans et plus*
                    </td>
                    <td className="p-4" data-id="element-1246" data-mp="3enyh8pa851ju">
                      100% du Smic
                      <br data-id="element-1247" data-mp="3eoq4ncto3sz1" />
                      <span className="font-bold text-primary text-lg" data-id="element-1248" data-mp="2qydml94pkfuq">
                        1 867,02 €
                      </span>
                    </td>
                    <td className="p-4" data-id="element-1249" data-mp="2m0u4fy4w3ixi">
                      100% du Smic
                      <br data-id="element-1250" data-mp="2zrphznqc2o7f" />
                      <span className="font-bold text-primary text-lg" data-id="element-1251" data-mp="2zrz1csgvhx45">
                        1 867,02 €
                      </span>
                    </td>
                    <td className="p-4" data-id="element-1252" data-mp="279l9ram4r7di">
                      100% du Smic
                      <br data-id="element-1253" data-mp="2391cm71k43rd" />
                      <span className="font-bold text-primary text-lg" data-id="element-1254" data-mp="237qbyg3erc4h">
                        1 867,02 €
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-sm text-muted-foreground mt-4 text-center" data-id="element-1255" data-mp="t6xhzudnaf5x">
              * Ou salaire minimum conventionnel (SMC) s'il est plus favorable.
              Les montants sont donnés à titre indicatif sur la base du SMIC en
              vigueur.
            </p>
          </div>

          <div className="mt-16 text-center" data-id="element-1256" data-mp="1gwru29q53zp4">
            <Button onClick={scrollToForm} className="bg-primary hover:bg-primary-dark text-white text-lg px-8 py-6 rounded-full shadow-lg hover:scale-105 transition-transform" data-id="element-1257" data-mp="1c01ctj2lmy24">
              Estimer mon besoin de recrutement{' '}
              <ArrowDownCircle className="ml-2 w-5 h-5" data-id="element-1258" data-mp="3rqnvl15avnyz" />
            </Button>
          </div>
        </div>
      </section>

      {/* Profils formés & Accompagnement */}
      <section className="py-24 bg-muted" data-id="element-1259" data-mp="3mt49jf2d26wh">
        <div className="container max-w-6xl mx-auto" data-id="element-1260" data-mp="229sddcgahkaf">
          <div className="max-w-3xl mx-auto" data-id="element-1261" data-mp="22aah0u5a70sd">
            {/* Accompagnement */}
            <div data-id="element-1262" data-mp="277ac6a0lej4p">
              <SectionHeading title="Notre accompagnement" className="mb-12" data-id="element-1263" data-mp="277ttppmbz5i7" />
              <StepList steps={ENTREPRISE_STEPS} data-id="element-1264" data-mp="1tgf9jfgosy9k" />

              {/* Engagement Maître d'Apprentissage */}
              <div className="mt-12 bg-lavande/20 p-8 rounded-3xl border border-lavande/50 flex gap-6 items-start group hover:-translate-y-1 transition-transform" data-id="element-1265" data-mp="1xh8xu9y1kf2z">
                <div className="w-16 h-16 bg-lavande rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform" data-id="element-1266" data-mp="1oinam1hmkbvv">
                  <Award className="w-8 h-8 text-primary-dark animate-soft-bounce" data-id="element-1267" data-mp="1akfge1bz3ooe" />
                </div>
                <div data-id="element-1268" data-mp="1em0qjex4houw">
                  <h4 className="font-extrabold font-heading text-xl text-primary-dark mb-3" data-id="element-1269" data-mp="34wn52wxpb9bq">
                    L'engagement Maître d'Apprentissage
                  </h4>
                  <p className="text-primary-dark/80 leading-relaxed font-medium" data-id="element-1270" data-mp="38vutisa299nc">
                    En recrutant un alternant, vous vous engagez à désigner un
                    maître d'apprentissage chargé de l'accompagner, de lui
                    transmettre son savoir-faire et de suivre sa progression au
                    quotidien. Tout au long de la formation, des points
                    réguliers sont organisés entre l'entreprise, l'alternant et
                    notre équipe pédagogique. Chez Zillenium, on vous accompagne
                    pour de vrai.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA / Formulaire */}
      <section id="formulaire-recrutement" className="py-24 bg-primary-dark text-white relative overflow-hidden scroll-mt-16" data-id="element-1271" data-mp="qp4eo4p5t9zo">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary rounded-full blur-[120px] opacity-40 pointer-events-none" data-id="element-1272" data-mp="1o5baia1najny" />
        <div className="container max-w-4xl mx-auto text-center relative z-10" data-id="element-1273" data-mp="1qppz4vsmijq9">
          <h2 className="text-4xl md:text-5xl font-extrabold font-heading mb-8" data-id="element-1274" data-mp="1vmpx0jfbkg6a">
            Confiez-nous votre recrutement
          </h2>
          <p className="text-xl md:text-2xl text-lavande mb-12 max-w-3xl mx-auto leading-relaxed font-medium" data-id="element-1275" data-mp="20lawuhqnsxu7">
            "Vous cherchez à renforcer vos équipes avec un alternant motivé ?
            Remplissez ce formulaire pour nous faire part de votre besoin."
          </p>
          <div className="mt-8 text-primary-dark" data-id="element-1276" data-mp="2el2f4uo7l0e0">
            <EntrepriseForm data-id="element-1277" data-mp="2jd3syl10yz65" />
          </div>
          <div className="mt-12 pt-8 border-t border-white/10" data-id="element-1278" data-mp="2jeeqw47shcpc">
            <Link to="/candidater" className="text-lg text-lavande hover:text-white transition-colors underline underline-offset-4" data-id="element-1279" data-mp="2ocooelgzkpe4">
              Vous cherchez une formation ? Candidater
            </Link>
          </div>
        </div>
      </section>
    </div>;
}